import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { FeaturesModule } from '../../features/features.module';
import { SharedDependenciesModule } from '../../shared';
import { CommonUIModule, SharedUiModule } from '../../shared-ui';

import { AirQualitySensorPanelComponent } from './air-quality-sensor-panel/air-quality-sensor-panel.component';
import { CsPanelComponent } from './cs-panel/cs-panel.component';
import { EditDeviceNameModalComponent } from './edit-device-name-modal/edit-device-name-modal.component';
import { FhtChannelPanelComponent } from './fht-channel-panel/fht-channel-panel.component';
import { FloorHeatingThermostatManagerComponent } from './floor-heating-thermostat-manager/floor-heating-thermostat-manager.component';
import { FhtManagerModalComponent } from './managers/fht-manager-modal/fht-manager-modal.component';
import { SrcManagerModalComponent } from './managers/src-manager-modal/src-manager-modal.component';
import { SrcModalManagerDirective } from './managers/src-modal-manager/src-modal-manager.directive';
import { OtherDevicesPanelComponent } from './other-devices-panel/other-devices-panel.component';
import { OtherRoomPanelComponent } from './other-room-panel/other-room-panel.component';
import { RoomPanelComponent } from './room-panel/room-panel.component';
import { RoomWarningComponent } from './room-warning/room-warning.component';
import { SingleRoomControlComponent } from './single-room-control.component';
import { SrcHeatingPanelComponent } from './src-heating-panel/src-heating-panel.component';
import { SrcOtherRoomHeatingPanelComponent } from './src-other-room-heating-panel/src-other-room-heating-panel.component';
import {
  CommissioningAddVentilationModalComponent,
  CommissioningDeleteDeviceConfirmModalComponent,
} from './src-overlay/commissioning';
import { CommissioningAddRoomModalComponent } from './src-overlay/commissioning/commissioning-add-room-modal/commissioning-add-room-modal.component';
import { CommissioningAddRoomModalStandaloneComponent } from './src-overlay/commissioning/commissioning-add-room-standalone-modal/commissioning-add-room-standalone-modal.component';
import { CommissioningAssignChannelModalComponent } from './src-overlay/commissioning/commissioning-assign-channel-modal/commissioning-assign-channel-modal.component';
import { CommissioningAssignHeatingCircuitModalComponent } from './src-overlay/commissioning/commissioning-assign-heating-circuit-modal/commissioning-assign-heating-circuit-modal.component';
import { CommissioningAssignmentLoaderModalComponent } from './src-overlay/commissioning/commissioning-assignment-loader-modal/commissioning-assignment-loader-modal.component';
import { CommissioningCodeModalComponent } from './src-overlay/commissioning/commissioning-code-modal/commissioning-code-modal.component';
import { CommissioningCodeFormComponent } from './src-overlay/commissioning/commissioning-code-modal/views/commissioning-code-form/commissioning-code-form.component';
import { CommissioningScanCodeComponent } from './src-overlay/commissioning/commissioning-code-modal/views/commissioning-scan-code/commissioning-scan-code.component';
import { CommissioningDeleteRoomConfirmModalComponent } from './src-overlay/commissioning/commissioning-delete-room-confirm-modal/commissioning-delete-room-confirm-modal.component';
import { CommissioningDeviceTypeModalComponent } from './src-overlay/commissioning/commissioning-device-type-modal/commissioning-device-type-modal.component';
import { CommissioningEditRoomModalComponent } from './src-overlay/commissioning/commissioning-edit-room-modal/commissioning-edit-room-modal.component';
import { CommissioningFinalResultModalComponent } from './src-overlay/commissioning/commissioning-final-result-modal/commissioning-final-result-modal.component';
import { CommissioningPairingModalComponent } from './src-overlay/commissioning/commissioning-pairing-modal/commissioning-pairing-modal.component';
import { CommissioningPairingResultModalComponent } from './src-overlay/commissioning/commissioning-pairing-result-modal/commissioning-pairing-result-modal.component';
import { CommissioningProcessModalComponent } from './src-overlay/commissioning/commissioning-process-modal/commissioning-process-modal.component';
import { CommissioningReminderModalComponent } from './src-overlay/commissioning/commissioning-reminder-modal/commissioning-reminder-modal.component';
import { CommissioningSpinnerComponent } from './src-overlay/commissioning/commissioning-spinner/commissioning-spinner.component';
import { OverflowShadowDirective } from './src-overlay/commissioning/overflow-shadow.directive';
import { AddedDeviceItemComponent } from './src-overlay/src-commissioning-overlay/commissioning-overview/all-added-devices-modal/added-device-item/added-device-item.component';
import { AllAddedDevicesModalComponent } from './src-overlay/src-commissioning-overlay/commissioning-overview/all-added-devices-modal/all-added-devices-modal.component';
import { AllAddedRoomsModalComponent } from './src-overlay/src-commissioning-overlay/commissioning-overview/all-added-rooms-modal/all-added-rooms-modal.component';
import { CommissioningOverviewComponent } from './src-overlay/src-commissioning-overlay/commissioning-overview/commissioning-overview.component';
import { SrcDevicePanelComponent } from './src-overlay/src-commissioning-overlay/commissioning-overview/src-device-panel/src-device-panel.component';
import { SrcDevicesComponent } from './src-overlay/src-commissioning-overlay/commissioning-overview/src-devices/src-devices.component';
import { SrcNotAddedOtherRoomComponent } from './src-overlay/src-commissioning-overlay/commissioning-overview/src-rooms/src-not-added-other-room/src-not-added-other-room.component';
import { SrcOtherRoomComponent } from './src-overlay/src-commissioning-overlay/commissioning-overview/src-rooms/src-other-room/src-other-room.component';
import { SrcRoomComponent } from './src-overlay/src-commissioning-overlay/commissioning-overview/src-rooms/src-room/src-room.component';
import { DeactivatedSrcNotificationModalComponent } from './src-overlay/src-commissioning-overlay/deactivated-src-notification-modal/deactivated-src-notification-modal.component';
import { ManageRoomModalComponent } from './src-overlay/src-commissioning-overlay/manage-room-modal/manage-room-modal.component';
import { OfflineDeviceComponent } from './src-overlay/src-commissioning-overlay/offline-device/offline-device.component';
import { SelectHeatingCircuitModalComponent } from './src-overlay/src-commissioning-overlay/select-heating-circuit-modal/select-heating-circuit-modal.component';
import { SrcCommissioningOverlayComponent } from './src-overlay/src-commissioning-overlay/src-commissioning-overlay.component';
import { SrcDetailsOverlayComponent } from './src-overlay/src-details-overlay/src-details-overlay.component';
import { SrcOverlayComponent } from './src-overlay/src-overlay.component';
import { SrcSettingsActivationComponent } from './src-overlay/src-settings-overlay/src-settings-activation/src-settings-activation.component';
import { SrcSettingsAlgorithmsComponent } from './src-overlay/src-settings-overlay/src-settings-algorithms/src-settings-algorithms.component';
import { SrcSettingsOverlayComponent } from './src-overlay/src-settings-overlay/src-settings-overlay.component';
import { ZigbeeTopologyDeviceComponent } from './src-overlay/zigbee-topology-modal/topology-device/zigbee-topology-device.component';
import { ZigbeeTopologyModalComponent } from './src-overlay/zigbee-topology-modal/zigbee-topology-modal.component';
import { TrvPanelComponent } from './trv-panel/trv-panel.component';
import { SrcSettingsPumpControlComponent } from './src-overlay/src-settings-overlay/src-settings-algorithms/src-settings-pump-control/src-settings-pump-control.component';
import { SrcSettingsCondensateAvoidanceComponent } from './src-overlay/src-settings-overlay/src-settings-algorithms/src-settings-condensate-avoidance/src-settings-condensate-avoidance.component';

@NgModule({
  imports: [SharedDependenciesModule, CommonUIModule, SharedUiModule, FeaturesModule],
  exports: [SingleRoomControlComponent, SrcOverlayComponent, CsPanelComponent],
  declarations: [
    AirQualitySensorPanelComponent,
    SrcOverlayComponent,
    SrcDetailsOverlayComponent,
    SrcCommissioningOverlayComponent,
    SrcSettingsOverlayComponent,
    SrcSettingsActivationComponent,
    SrcSettingsAlgorithmsComponent,
    SrcSettingsCondensateAvoidanceComponent,
    SingleRoomControlComponent,
    SrcSettingsPumpControlComponent,
    TrvPanelComponent,
    RoomPanelComponent,
    OtherRoomPanelComponent,
    OtherDevicesPanelComponent,
    FhtChannelPanelComponent,
    CsPanelComponent,
    RoomWarningComponent,
    SrcManagerModalComponent,
    FhtManagerModalComponent,
    ZigbeeTopologyModalComponent,
    SrcModalManagerDirective,
    OfflineDeviceComponent,
    ManageRoomModalComponent,
    AllAddedRoomsModalComponent,
    AllAddedDevicesModalComponent,
    DeactivatedSrcNotificationModalComponent,
    CommissioningOverviewComponent,
    SrcDevicesComponent,
    SrcDevicePanelComponent,
    SrcRoomComponent,
    SrcOtherRoomComponent,
    SrcNotAddedOtherRoomComponent,
    SrcHeatingPanelComponent,
    SrcOtherRoomHeatingPanelComponent,
    FloorHeatingThermostatManagerComponent,
    ZigbeeTopologyDeviceComponent,
    CommissioningProcessModalComponent,
    CommissioningDeviceTypeModalComponent,
    CommissioningAddRoomModalComponent,
    CommissioningAddRoomModalStandaloneComponent,
    CommissioningEditRoomModalComponent,
    CommissioningDeleteRoomConfirmModalComponent,
    CommissioningDeleteDeviceConfirmModalComponent,
    CommissioningCodeModalComponent,
    CommissioningSpinnerComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningReminderModalComponent,
    CommissioningCodeFormComponent,
    CommissioningFinalResultModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningAssignHeatingCircuitModalComponent,
    CommissioningAssignChannelModalComponent,
    CommissioningScanCodeComponent,
    OverflowShadowDirective,
    EditDeviceNameModalComponent,
    SelectHeatingCircuitModalComponent,
    AddedDeviceItemComponent,
    CommissioningAddVentilationModalComponent,
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SingleRoomControlModule {}
